<template>
	<div class="h-screen flex w-full bg-img" id="redefinir-senha">
		<div
			v-if="podeRedefinir"
			class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
		>
			<transition name="fade" appear>
				<vx-card>
					<div slot="no-body" class="full-page-bg-color">
						<div class="vx-row">
							<div
								class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
							>
								<img
									src="@/assets/images/views/senha/reset-password.png"
									alt="login"
									class="mx-auto"
								/>
							</div>
							<div
								id="content-redefinir-senha"
								class="relative vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg"
							>
								<div class="p-8">
									<div class="vx-card__title mb-8">
										<h4 class="mb-4">Redefinir senha</h4>
										<p>Digite sua nova senha.</p>
									</div>
									<form id="form-redefinir-senha" @submit.prevent="redefinirSenha">
										<vs-input
											type="password"
											label="Nova senha"
											v-model="novaSenha"
											name="senha"
											class="w-full mb-6"
										/>
										<vs-input
											type="password"
											label="Confirmar nova senha"
											name="confirmar_senha"
											v-model="confirmarNovaSenha"
											class="w-full mb-8"
										/>

										<ld-button
											type="border"
											to="/acessar"
											class="px-4 w-full md:w-auto"
											>Voltar ao início</ld-button
										>

										<ld-button
											buttonType="submit"
											class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
											>Redefinir senha</ld-button
										>
									</form>
								</div>
							</div>
						</div>
					</div>
				</vx-card>
			</transition>
		</div>

		<div
			v-else-if="podeRedefinir == false"
			class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
		>
			<transition name="fade" appear>
				<div>
					<img
						src="@/assets/images/views/senha/link-invalido.png"
						alt="graphic-404"
						class="mx-auto mb-4 max-w-full"
					/>
					<h1 class="mb-12 text-5xl d-theme-heading-color">
						Este link não é mais válido.
					</h1>
					<p class="mb-4 sm:mb-16 l-theme-text-inverse">
						Acesse a página de recuperação de senha e solicite novamente.
					</p>
					<vs-button size="large" to="/senha/recuperar">Ir para página de recuperação de senha</vs-button>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import ErrorHelper from "../../../helpers/ErrorHelper";
import Autenticacao from '../../../models/Autenticacao';
import ComponentHelper from '../../../helpers/ComponentHelper';

export default {
	name: "RedefinirSenha",
	data() {
		return {
			novaSenha: null,
			confirmarNovaSenha: null,
			podeRedefinir: null,
		};
	},
	computed: {
		pk() {
			return this.$route.params.pk;
		}
	},
	methods: {
		async redefinirSenha() {
			const loadingRedefinirSenha = this.$vsloading({
				container: "#content-redefinir-senha",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {

				Autenticacao.validarSenhas(this.novaSenha, this.confirmarNovaSenha);

				const { token } = await Autenticacao.redefinirSenha(this.pk, this.novaSenha);

				this.novaSenha = null;
				this.confirmarNovaSenha = null;

				const { navigate } = await Autenticacao.autenticarUsuario(token);

				ComponentHelper.deleteAllVsNotifications();

				navigate(({routeName, params}) => {
					this.$navigate({
						name: routeName,
						params
					});
				});

			} catch (error) {
				Autenticacao.messageErrorRedefinirSenha(error);
				ErrorHelper.renderFormError("#form-redefinir-senha", error);
			} finally {
				loadingRedefinirSenha.hide();
			}
		},
		errorPageNotFound(error) {
			console.error(error)
            if (error.response && error.response.status === 404) {
                this.$navigate({name: 'logout'});
            }
        },
		async verificarPkParaRedefinicaoDeSenha() {

			if (!this.pk) {
				this.$navigate({ name: "login" });
			}

			const loadingPodeRedefinir = this.$vsloading({
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				const {expirada, utilizada} = await Autenticacao.verificarPkParaRedefinicaoDeSenha(this.pk);
				this.podeRedefinir = !expirada && !utilizada;

			} catch (error) {
				this.errorPageNotFound(error);
				ErrorHelper.renderFormError("#form-redefinir-senha", error);
			} finally {
				loadingPodeRedefinir.hide();
			}
		},
	},
	created() {
		this.verificarPkParaRedefinicaoDeSenha();
	}
};
</script>

<style lang="scss" scoped src="./redefinir_senha.scss"></style>
